import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 300,
    maxWidth: 400,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 300,
    },
  },
};

const categories = [
  'Kategorie1',
  'Kategorie2',
  'Kategorie3',
  'Kategorie4',
  'Kategorie5',
  'Kategorie6'  
];

class MovieCategories extends React.Component {

 constructor(props)  {
    super(props)

this.state = {
  categories: [],
}


}


async componentDidMount(){

  var cats = []
  var clipid = this.getUrlVars()["id"]
  if (clipid) {
    console.log("in moviecategories with id: ",clipid );
    cats =  await this.getCategorie(); 
    cats = cats.clips.filter( item => item.id == clipid)[0].categories
}

if (this.getUrlVars()["cat"]) {
  console.log("in moviecategories with cats: ",this.getUrlVars()["cat"].split(","));
  cats = this.getUrlVars()["cat"].split(",")
}

this.setState({categories: cats})

}

getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
      vars[key] = value;
  });
  return vars;
}


  handleChange = event => {
    this.setState({ categories: event.target.value });    
    this.props.exchangeFunc(event.target.value);
  };



  getCategorie = async () => {
    const retval = await fetch('https://api2.joobster.at/portal/group/5b4ea9901bb6981a06c5be80/clip');
    //const retval = await fetch('https://portal.joobster.at/portal/group/5b4ea9901bb6981a06c5be80/clip');
    //console.log("getCategorie....", retval.json())
    return retval.json(); 
    //return fetch('https://portal.joobster.at/portal/group/5b4ea9901bb6981a06c5be80/clip'); 
   }


  render() {
    const { classes, theme } = this.props;

    return (
      <div className={classes.root}>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="select-multiple">Kategorie</InputLabel>
          <Select
            multiple
            value={this.state.categories}
            onChange={this.handleChange}
            input={<Input id="select-multiple" />}
            MenuProps={MenuProps}
          >
            {this.props.categories.map(cat => (
              <MenuItem
                key={cat}
                value={cat}
                style={{
                  fontWeight:
                    this.state.categories.indexOf(cat) === -1
                      ? theme.typography.fontWeightRegular
                      : theme.typography.fontWeightMedium,
                }}
              >
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }
}

MovieCategories.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(MovieCategories);


// WEBPACK FOOTER //
// ./src/modules/movie-browser/movieCategories.js